export default __webpack_public_path__ + "static/media/accounting-2.050a3e40.jpg";